import { IDotXetHocVuPhamViViewModel } from "../../../model/response/xet-hoc-vu/IDotXetHocVuPhamViViewModel";
import { IDotXetHocVuPhamVi } from "../../../model/response/xet-hoc-vu/IDotXetHocVuPhamVi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const eDotXetHocVuPhamViActionsObj = {
    LOAD_BY_DOT_XET_START: 0,
    LOAD_BY_DOT_XET_SUCCESS: [] as IDotXetHocVuPhamViViewModel[],
    LOAD_BY_DOT_XET_ERROR: "",

    SAVE_START: {} as IDotXetHocVuPhamVi,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_ADD_MODAL: {} as number,
    CLOSE_ADD_MODAL: undefined,
}

export const eDotXetHocVuPhamViActionIds = generateActionTypeIds(eDotXetHocVuPhamViActionsObj, "DOT_XET_HOC_VU_PHAM_VI");
export type IDotXetHocVuPhamViActionTypes = IGenericActionType<typeof eDotXetHocVuPhamViActionsObj, "DOT_XET_HOC_VU_PHAM_VI">;